import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/Popover';
import { editorFieldsForTable } from '@/api/ruleRecommendations';
import type { RuleTableId, RuleThresholds } from '@/types/ruleRecommendations';

export function RuleLogicEditor({
  tableId,
  thresholds,
  onChange,
  onReset,
}: {
  tableId: RuleTableId;
  thresholds: RuleThresholds;
  onChange: (next: RuleThresholds) => void;
  onReset: () => void;
}) {
  const fields = editorFieldsForTable(tableId);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="link" size="sm">
          Edit rules
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 space-y-3">
        <div>
          <p className="text-sm font-semibold text-foreground">Edit rules</p>
          <p className="mt-0.5 text-xs text-foreground-muted">
            Changes apply for this session only and are not saved.
          </p>
        </div>
        {fields.map((field) => (
          <label key={field.key} className="block">
            <span className="mb-1 block text-xs font-medium text-foreground-muted">{field.label}</span>
            <Input
              type="number"
              step={field.step}
              value={thresholds[field.key]}
              onChange={(event) => {
                const parsed = Number(event.target.value);
                if (!Number.isFinite(parsed)) return;
                onChange({ ...thresholds, [field.key]: parsed });
              }}
            />
          </label>
        ))}
        <Button type="button" variant="secondary" size="sm" onClick={onReset}>
          Reset to defaults
        </Button>
      </PopoverContent>
    </Popover>
  );
}
